"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectWeekStartDayOption_1 = require("../actions/selectWeekStartDayOption");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var Dropdown_1 = require("office-ui-fabric-react/lib/Dropdown");
var owa_calendar_configuration_1 = require("owa-calendar-configuration");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var owa_datetime_strings_1 = require("owa-strings/owa-datetime-strings");
var AppearanceFull = /** @class */ (function (_super) {
    tslib_1.__extends(AppearanceFull, _super);
    function AppearanceFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onWeekStartDayChange = function (option) {
            selectWeekStartDayOption_1.default(option.key);
        };
        return _this;
    }
    AppearanceFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, calendarConfiguration = _a.calendarConfiguration;
        if (!calendarConfiguration) {
            return null;
        }
        var weekStartDay = owa_options_core_1.getFallbackValueIfNull(optionStore.weekStartDay, calendarConfiguration.WeekStartDay);
        var dayOfweekOptions = [
            { key: 0, text: owa_datetime_strings_1.default.calendarDayOfWeek_Sunday },
            { key: 1, text: owa_datetime_strings_1.default.calendarDayOfWeek_Monday },
            { key: 2, text: owa_datetime_strings_1.default.calendarDayOfWeek_Tuesday },
            { key: 3, text: owa_datetime_strings_1.default.calendarDayOfWeek_Wednesday },
            { key: 4, text: owa_datetime_strings_1.default.calendarDayOfWeek_Thursday },
            { key: 5, text: owa_datetime_strings_1.default.calendarDayOfWeek_Friday },
            { key: 6, text: owa_datetime_strings_1.default.calendarDayOfWeek_Saturday },
        ];
        return (React.createElement(Dropdown_1.Dropdown, { selectedKey: weekStartDay, label: owa_options_strings_1.default.options_appearance_weekstartdayLabel, options: dayOfweekOptions, onChanged: this.onWeekStartDayChange }));
    };
    AppearanceFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            calendarConfiguration: function () { return owa_calendar_configuration_1.getCalendarConfiguration(); },
        })
    ], AppearanceFull);
    return AppearanceFull;
}(React.Component));
exports.default = AppearanceFull;
//# sourceMappingURL=AppearanceFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-calendar-appearance-option/lib/components/AppearanceFull.js
// module id = 5262
// module chunks = 2